export function reportAsyncError(error: unknown): void {
  // Surface the error to the global handler (and Sentry) on its own tick so it is reported
  // without being caught by the calling code and misattributed to that flow.
  setTimeout(() => {
    throw error
  })
}
